import React, { useState, useEffect } from 'react';
import cl from './Reviews.module.css';
import { reviewsAPI, Review } from '../../api/api';

const Reviews: React.FC = () => {
    const [reviews, setReviews] = useState<Review[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadReviews = async () => {
            try {
                setLoading(true);
                const data = await reviewsAPI.getAll();
                setReviews(data);
                setError(null);
            } catch (err) {
                setError('Не удалось загрузить отзывы');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        loadReviews();
    }, []);

    const nextReview = () => {
        setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
    };

    const prevReview = () => {
        setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
    };

    const goToReview = (index: number) => {
        setCurrentIndex(index);
    };

    // Получаем текущий отзыв с проверкой
    const currentReview = reviews[currentIndex];

    if (loading) {
        return (
            <div className={`${cl.home__row}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Отзывы</h2>
                        <p>Загрузка отзывов...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={`${cl.home__row}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Отзывы</h2>
                        <p className="error">{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (reviews.length === 0) {
        return (
            <div className={`${cl.home__row}`}>
                <div className={`${cl.home__cell}`}>
                    <div className={`${cl.home__cell__block}`}>
                        <h2>Отзывы</h2>
                        <p>Пока нет отзывов</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`${cl.home__row}`}>
            <div className={`${cl.home__cell}`}>
                <div className={`${cl.home__cell__block}`}>
                    <h2>Отзывы</h2>

                    <div className={cl.reviewsContainer}>
                        {/* Карточка отзыва */}
                        <div className={cl.reviewCard}>
                            <div className={cl.reviewHeader}>
                                <div className={cl.reviewAvatar}>
                                    <img
                                        src={currentReview.image_reviews_base64
                                            ? (currentReview.image_reviews_base64.startsWith('data:')
                                                ? currentReview.image_reviews_base64
                                                : `data:image/jpeg;base64,${currentReview.image_reviews_base64}`)
                                            : '/default-avatar.jpg'}
                                        alt={currentReview.name_reviews}
                                    />
                                </div>
                                <div className={cl.reviewInfo}>
                                    <h3 className={cl.reviewName}>{currentReview.name_reviews}</h3>
                                    {/* Убрали position, т.к. его нет в интерфейсе Review */}
                                </div>
                                <div className={cl.reviewQuote}>
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                                    </svg>
                                </div>
                            </div>
                            <p className={cl.reviewText}>
                                {currentReview.text_reviews}
                            </p>
                        </div>

                        {/* Кнопка вправо */}
                        <div className={cl.reviewArrows}>
                            <button className={`${cl.reviewBtn} ${cl.reviewBtnPrev}`} onClick={prevReview} aria-label="Предыдущий отзыв">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>

                            <button className={`${cl.reviewBtn} ${cl.reviewBtnNext}`} onClick={nextReview} aria-label="Следующий отзыв">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>

                        {/* Индикаторы (dots) */}
                        <div className={cl.reviewDots}>
                            {reviews.map((_, index) => (
                                <button
                                    key={index}
                                    className={`${cl.reviewDot} ${index === currentIndex ? cl.reviewDotActive : ''}`}
                                    onClick={() => goToReview(index)}
                                    aria-label={`Перейти к отзыву ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reviews;